import { HistoricAlarm } from '../api-new';
import { format_date, format_duration } from '../shared/formatters';
// import { Note } from '../shared/note';

export const COLS_FULL: {
  key: keyof HistoricAlarm;
  label: React.ReactNode;
  truncate?: boolean;
  searchable: boolean;
  sortable: boolean;
  cell?: (row: HistoricAlarm) => React.ReactNode;
}[] = [
  {
    key: 'al_unix_start',
    label: 'Timestamp',
    searchable: true,
    sortable: true,
    cell: (row) => format_date(row.al_unix_start),
  },
  {
    key: 'al_type',
    label: 'Tipologia',
    searchable: true,
    sortable: true,
    cell: (row) => <span className="capitalize">{row.al_type}</span>,
  },
  {
    key: 'al_text',
    label: 'Valore',
    searchable: true,
    sortable: true,
  },
  {
    key: 'ws_id',
    label: 'Centro',
    searchable: true,
    sortable: true,
  },
  {
    key: 'al_unix_end',
    label: 'Status',
    searchable: true,
    sortable: true,
    cell: (row) => (
      <span className="uppercase">
        {row.al_unix_end > 0 ? 'closed' : 'open'}
      </span>
    ),
  },
  {
    key: 'al_timestamp',
    label: 'Durata',
    searchable: true,
    sortable: true,
    cell: (row) => format_duration(row.al_unix_end - row.al_unix_start),
  },
];
